var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipBtnBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 143,
    viewBox: "0 0 100 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.8755C0 53.9344 8.05887 45.8755 18 45.8755H81.7908C90.9624 45.8755 98.6675 38.9794 99.6807 29.8639L101.22 16.0116C102.234 6.89608 109.939 0 119.11 0H188C197.941 0 206 8.05888 206 18V125C206 134.941 197.941 143 188 143H119.352C110.078 143 102.322 135.954 101.434 126.723L99.4666 106.265C98.5787 97.034 90.8228 89.9883 81.5493 89.9883H18C8.05889 89.9883 0 81.9294 0 71.9883V63.8755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipBtnBg);
export default __webpack_public_path__ + "static/media/skip-btn-bg.9df5597eaa7fcc838d7962ef88090699.svg";
export { ForwardRef as ReactComponent };